import { POSA_CDN_PREFIX } from "../constants";
import { LANGUAGE } from "../i18n/i18n";
import { POSA_WORDINGS } from "@tootsweet/model/lottery/POSAType";

export function buildPreviewLinkForNonCustomPOSA(
  posaRatio: string,
  shortId: string,
  isCustom: boolean,
  isOnline: boolean
) {
  let res = "";

  if (isOnline) {
    res = `jetpack/${POSA_CDN_PREFIX}/png/${posaRatio}_${shortId.toLowerCase().replaceAll(" ", "")}_${LANGUAGE === "fr" ? "fr" : "en"}.png`;
  } else {
    res = `jetpack/${POSA_CDN_PREFIX}/png/${posaRatio}_${shortId.toLowerCase().replaceAll(" ", "")}_${LANGUAGE === "fr" ? "fr" : "en"}_${POSA_WORDINGS.gift}.png`;
  }

  return res;
}
